import { render, staticRenderFns } from "./GroupSearch.vue?vue&type=template&id=5ba63f57&scoped=true&"
import script from "./GroupSearch.vue?vue&type=script&lang=js&"
export * from "./GroupSearch.vue?vue&type=script&lang=js&"
import style0 from "./GroupSearch.vue?vue&type=style&index=0&id=5ba63f57&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba63f57",
  null
  
)

export default component.exports